module.exports = __webpack_public_path__ + "media/images/athletes/478-5e15520532c8e0af310400f6fc289ee5.png";